import { getCookie } from './cookies.service';
import { useData } from 'shell/dataContext';

export const getUserCultureIdFromCookie = () => {
    return getCookie('UC');
};

export const isSpecialTranslationCulture = () => {
    const { isBreakLineCulture } = useData() ?? {};
    return isBreakLineCulture;
};
